require('angular-drag-and-drop-lists');

const deps = ['dndLists'];

module.exports = angular.module('bench.ui.dndLists', deps);
